/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useEffect, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthForm } from '../../components/AuthForm';
import { ResetPasswordSuccessMessage } from '../../components/ResetPasswordSuccessMessage';
import { Auth0ErrorCodes } from '../../flows/auth0_flow/Auth0ErrorCodes';
import { validate_email } from '../../flows/auth0_flow/validators/validate_email';
import { Auth0ErrorMessage } from '../../flows/auth0_flow/_components/Auth0ErrorMessage';
import { EmailInput } from '../../flows/auth0_flow/_components/inputs/EmailInput';
import { useAuth0 } from '../../hooks/useAuth0';
import { useQueryParams } from '../../hooks/useQueryParams';
import { AuthRoutePaths } from '../AuthRoutePaths.enum';
import styled from 'styled-components';

const NEW_PLATFORM_URL = 'https://www.forumconhecimento.com.br';

const LegacyMigrationMessage: React.FC<{ newStoreUrl: string }> = ({
  newStoreUrl
}) => (
  <MigrationMessageBox>
    <MigrationMessageTitle>
      Prezado(a) cliente/parceiro(a) FÓRUM,
    </MigrationMessageTitle>
    <MigrationMessageParagraph>
      Temos o prazer de informar que lançamos uma nova loja e um novo ambiente
      para visualização dos livros digitais.
    </MigrationMessageParagraph>
    <MigrationMessageSubtitle>
      Acesso aos livros já adquiridos
    </MigrationMessageSubtitle>
    <MigrationMessageParagraph as="div">
      Se você chegou aqui para visualizar os livros digitais adquiridos na loja
      anterior, basta informar seu e-mail e criar uma nova senha neste ambiente
      de visualização. Esse procedimento é realizado apenas uma vez. A partir de
      então, seu acesso será sempre pelo endereço:
      <br />
      <MigrationMessageLink
        href={NEW_PLATFORM_URL}
        target="_blank"
        rel="noopener noreferrer">
        {NEW_PLATFORM_URL}
      </MigrationMessageLink>
    </MigrationMessageParagraph>
    <MigrationMessageSubtitle>
      Compra de novos produtos
    </MigrationMessageSubtitle>
    <MigrationMessageParagraph as="div">
      Se você deseja adquirir novos produtos, conheça a nova loja FÓRUM em:
      <br />
      <MigrationMessageLink
        href={newStoreUrl}
        target="_blank"
        rel="noopener noreferrer">
        {newStoreUrl}
      </MigrationMessageLink>
    </MigrationMessageParagraph>
  </MigrationMessageBox>
);

function isLegacyMigrationParams(origin: string): {
  valid: boolean;
  originForUrl: string;
} {
  const originTrimmed = (origin || '').trim();
  const valid = originTrimmed.length > 0;
  return {
    valid,
    originForUrl: originTrimmed
      ? `https://${originTrimmed.replace(/^https?:\/\//i, '')}`
      : ''
  };
}

interface IProps {}

export const ResetPasswordPage: React.FC<IProps> = ({}) => {
  const auth0 = useAuth0();
  const query_params = useQueryParams();
  const [success, set_success] = useState(false);
  const [error, set_error] = useState<Auth0ErrorCodes | string>(null);
  const [loading, set_loading] = useState(false);

  const originParam = query_params.get('origin');
  const migrationParams = useMemo(
    () => isLegacyMigrationParams(originParam),
    [originParam]
  );

  return (
    <Container>
      <Form
        {...{
          show_back_link: !query_params.get('voltar'), // aparece o link de voltar se o link do AuthContent nao estiver visivel.
          disabled: loading && !success,
          success,
          error,
          email_from_query: query_params.get('email'),
          show_migration_message: migrationParams.valid,
          migration_origin_url: migrationParams.originForUrl,
          on_valid_form_submitted: (email) => {
            if (loading) {
              return;
            }

            set_loading(true);

            auth0
              .reset_password(email.trim().toLowerCase())
              .then(() => {
                set_success(true);
              })
              .catch((error) => {
                set_loading(false);
                set_error(error);
              });
          }
        }}
      />
    </Container>
  );
};

type ValidFields = {
  email: boolean;
};

interface IFormProps {
  show_back_link;
  disabled: boolean;
  email_from_query?: string;
  on_valid_form_submitted: (email: string) => any;
  error?: Auth0ErrorCodes | string;
  success: boolean;
  show_migration_message?: boolean;
  migration_origin_url?: string;
}

const Form: React.FC<IFormProps> = ({
  show_back_link,
  disabled,
  email_from_query,
  on_valid_form_submitted,
  error,
  success,
  show_migration_message,
  migration_origin_url
}) => {
  const [email, set_email] = useState('');
  const empty_valid_fields = { email: true };
  const [valid_fields, set_valid_fields] =
    useState<ValidFields>(empty_valid_fields);

  useEffect(() => {
    if (!email_from_query) {
      return;
    }

    set_email(email_from_query);
  }, [email_from_query]);

  function on_submit() {
    const valid_fields = {
      email: validate_email(email)
    };

    set_valid_fields(valid_fields);

    if (!valid_fields.email) {
      return;
    }

    on_valid_form_submitted(email.trim().toLowerCase());
  }

  return (
    <AuthForm
      {...{
        disabled,
        onSubmit: on_submit,
        title: 'Redefinir senha',
        contentBetweenLogoAndTitle:
          show_migration_message && migration_origin_url ? (
            <LegacyMigrationMessage newStoreUrl={migration_origin_url} />
          ) : undefined
      }}>
      {success ? (
        <ResetPasswordSuccessMessage {...{ email }} />
      ) : (
        <>
          <EmailInput
            {...{
              value: email,
              is_valid: valid_fields.email,
              on_change: (email) => {
                set_valid_fields(empty_valid_fields);
                set_email(email);
              }
            }}
          />

          {error && <Auth0ErrorMessage {...{ error }} />}

          <div className="spacer"></div>
          <div className="spacer"></div>
          <button
            {...{
              disabled
            }}>
            Redefinir minha senha
          </button>
        </>
      )}

      {show_back_link && (
        <div className="footer_action">
          <NavLink
            {...{
              to: `${AuthRoutePaths.LoginPage}${
                success ? `?email=${email}` : ''
              }`
            }}>
            Voltar
          </NavLink>
        </div>
      )}
    </AuthForm>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const MigrationMessageBox = styled.div`
  margin-bottom: 1.25rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f0fe 100%);
  border: 1px solid #c5d9f0;
  border-radius: 8px;
  text-align: left;
  max-width: 100%;
  box-sizing: border-box;
  text-align: justify;
`;

const MigrationMessageTitle = styled.p`
  margin: 0 0 0.75rem 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1a365d;
  line-height: 1.4;
`;

const MigrationMessageParagraph = styled.p`
  margin: 0 0 0.6rem 0;
  font-size: 0.85rem;
  color: #2d3748;
  line-height: 1.5;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

const MigrationMessageSubtitle = styled.p`
  margin: 0.75rem 0 0.35rem 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #2c5282;
  line-height: 1.4;
`;

const MigrationMessageLink = styled.a`
  color: #2b6cb0;
  text-decoration: none;
  word-break: break-all;
  &:hover {
    text-decoration: underline;
  }
`;

const Button = styled.button``;

const Text = styled.span``;
